// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__GOTH2","rootSuccess":"CompleteLink_rootSuccess__2eLQF","rootFailure":"CompleteLink_rootFailure__1NqaI","isDisabled":"CompleteLink_isDisabled__2bT-_"};